module.exports = __webpack_public_path__ + "img/50.9a17971a.jpg";